import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import InvDoc03Actions, { InvDoc03Types } from '../Stores/InvDoc03/Actions';

const getAppStore = state => state.app;

export function* invDoc03FetchInvDoc03({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(InvDoc03Actions.invDoc03FetchInvDoc03Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `invDoc/indexProcess/INV_DOC_03/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        InvDoc03Actions.invDoc03FetchInvDoc03Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InvDoc03Actions.invDoc03FetchInvDoc03Loading(false));
  }
}

export function* invDoc03CreateInvDoc03({ hdrIds }) {
  try {
    yield put(InvDoc03Actions.invDoc03CreateInvDoc03Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `invDoc/createProcess/INV_DOC_03`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InvDoc03Actions.invDoc03CreateInvDoc03Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InvDoc03Actions.invDoc03CreateInvDoc03Loading(false));
  }
}

export function* invDoc03GoToOrderDoc({ hdrId, itemId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/inbOrdDetail/update/${hdrId}/${itemId}`));
}

export const saga = [
  takeLatest(InvDoc03Types.INV_DOC03_FETCH_INV_DOC03, invDoc03FetchInvDoc03),
  takeLatest(InvDoc03Types.INV_DOC03_CREATE_INV_DOC03, invDoc03CreateInvDoc03),
  takeLatest(InvDoc03Types.INV_DOC03_GO_TO_ORDER_DOC, invDoc03GoToOrderDoc)
];
